import {Injectable} from '@angular/core'
import {Observable} from 'rxjs/Observable'

@Injectable()
export class FeatureSwitchMock {

  public isEnabled(feature): Observable<boolean>{
    return Observable.of(true)
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/tests/feature-switch.mock.ts